import { createFileRoute } from "@tanstack/react-router";
import { CallDetailManagement } from "@/features/call-details/CallDetailManagement";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_dashboard/call-details/")({
  component: CallDetailPage,
});

function CallDetailPage() {
  usePageTitle("通話明細管理");

  return <CallDetailManagement />;
}